// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review_section {
    width: 100%;
    height: 100%;
}

.review_section__active_path {
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
    color: var(--color-text-muted);
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: rtl;
}

.review_section--centered {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 13px;
    padding: 35px;
}

.review_section__spinner {
    width: 26px;
    height: 26px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: review_section__spin 0.7s linear infinite;
}

@keyframes review_section__spin {
    to { transform: rotate(360deg); }
}

.review_section__empty_icon {
    font-size: 35px;
    line-height: 1;
    color: var(--color-text-muted);
}

.review_section__empty_title {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-text);
    text-align: center;
}

.review_section__empty_desc {
    font-size: 13px;
    color: var(--color-text-muted);
    text-align: center;
    max-width: 352px;
    line-height: 1.5;
}

.review_section__action_btn {
    margin-top: 4px;
    padding: 7px 18px;
    background-color: var(--color-accent);
    color: #fff;
    border-radius: 3px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .review_section__action_btn:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.review_section__action_btn:disabled {
    opacity: 0.5;
    cursor: default;
}

/* Panes */
.review_section__pane {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

.review_section__pane--sidebar {
    background-color: var(--color-bg-2);
}

.review_section__pane_header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 13px 4px;
}

.review_section__pane_label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    user-select: none;
    flex-shrink: 0;
}

.review_section__refresh_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0;
    color: var(--color-text-muted);
    cursor: pointer;
    line-height: 1;
    border-radius: 3px;
    transition: color 0.15s, background-color 0.15s;
}

@media (pointer: fine) {
    .review_section__refresh_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.review_section__refresh_btn--active {
    color: var(--color-accent);
}


.review_section__refresh_spinner {
    width: 13px;
    height: 13px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: review_section__spin 0.7s linear infinite;
    flex-shrink: 0;
}

/* Branch select — flex sizing within this section's header/slot */
.review_section__pane_header > .branch_select {
    flex: 1 1 0;
    min-width: 60px;
}

.accordion__header_slot .branch_select {
    flex: 1 1 0;
    min-width: 60px;
}

/* Commit area */
.review_section__commit_area {
    padding: 9px 13px;
    border-bottom: 1px solid var(--color-border);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 7px;
    flex-shrink: 0;
}

.review_section__commit_input {
    min-width: 0;
    resize: none;
    padding: 6px 8px;
    font-size: 13px;
    font-family: inherit;
    background: var(--color-bg-3);
    color: var(--color-text);
    border: 1px solid var(--color-border);
    border-radius: 3px;
    outline: none;
    box-sizing: border-box;
    line-height: 1.4;
    height: 28px;
    overflow: hidden;
    transition: height 0.15s;
}

.review_section__commit_input:focus {
    border-color: var(--color-accent);
    height: 68px;
    overflow: auto;
}

.review_section__commit_error {
    font-size: 12px;
    color: #e05c5c;
    width: 100%;
}

.review_section__merge_hint {
    font-size: 12px;
    color: var(--color-danger, #e53e3e);
    width: 100%;
}

/* Repo-operation error banner: hidden entirely unless store.operationError is set. */
.review_section__error_banner {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 8px;
    padding: 8px 10px;
    border-radius: 6px;
    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);
    border: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 35%, transparent);
    color: var(--color-danger, #e53e3e);
    font-size: 12px;
    font-family: monospace;
    line-height: 1.5;
}

.review_section__error_banner_icon {
    flex-shrink: 0;
    font-family: sans-serif;
}

.review_section__error_banner_msg {
    flex: 1;
    min-width: 0;
    white-space: pre-wrap;
    word-break: break-word;
}

.review_section__error_banner_dismiss {
    flex-shrink: 0;
    cursor: pointer;
    font-family: sans-serif;
    font-size: 15px;
    line-height: 1;
    opacity: 0.7;
}

.review_section__error_banner_dismiss:hover {
    opacity: 1;
}

.review_section__error_banner_title {
    font-weight: bold;
}

.review_section__error_banner_hint {
    margin-top: 4px;
    font-size: 12px;
    opacity: 0.8;
}

.review_section__conflict_files {
    margin: 4px 0 0;
    padding-left: 18px;
}

.review_section__merge_btn {
    margin-top: 6px;
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    color: #fff;
    background: var(--color-danger, #e53e3e);
    border: none;
}

.review_section__merge_btn:disabled {
    opacity: 0.6;
    cursor: default;
}

.review_section__identity_form {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
}

.review_section__identity_input {
    max-width: 280px;
}

.review_section__commit_btn {
    align-self: flex-end;
    padding: 4px 15px;
    font-size: 13px;
    background-color: var(--color-accent);
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    flex-shrink: 0;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .review_section__commit_btn:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.review_section__commit_btn:disabled {
    opacity: 0.5;
    cursor: default;
}

/* File list */
.review_section__file_list {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 9px;
}

.review_section__no_changes {
    padding: 13px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.review_section__group {
    margin-top: 4px;
}

.review_section__group_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 9px 2px 13px;
}

.review_section__group_header_actions {
    display: flex;
    align-items: center;
    gap: 2px;
}

.review_section__group_label {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    user-select: none;
}

.review_section__group_action {
    font-size: 15px;
    line-height: 1;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 1px 6px;
    border-radius: 3px;
    transition: color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .review_section__group_action:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.review_section__file {
    position: relative;
    display: flex;
    align-items: center;
    gap: 7px;
    width: 100%;
    padding: 3px 13px;
    text-align: left;
    cursor: pointer;
    border-radius: 0;
    transition: background-color 0.1s;
}

@media (hover: none) {
    .review_section__file {
        padding: 5px 13px;
    }
}

@media (pointer: fine) {
    .review_section__file:hover {
        background-color: var(--color-bg-3);
    }
}

.review_section__file.active {
    background-color: var(--color-bg-3);
    outline: 1px solid var(--color-accent);
    outline-offset: -1px;
}

.review_section__file_status {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    min-width: 64px;
    flex-shrink: 0;
    text-transform: uppercase;
}

@media (hover: none) {
    .review_section__file_status {
        font-size: 12px;
        min-width: 68px;
    }
}

.review_section__file_status--staged {
    color: #6ca35e;
}

.review_section__file_status--unstaged {
    color: var(--color-accent);
}

.review_section__file_status--untracked {
    color: var(--color-text-muted);
}

.review_section__file_status--deleted {
    color: #e05c5c;
}

.review_section__file_status--conflicted {
    color: var(--color-danger, #e53e3e);
    font-weight: bold;
}

.review_section__file_status--resolved {
    color: #6ca35e;
}

.review_section__file_path {
    font-size: 13px;
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
}

.review_section__file_actions {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding-left: 28px;
    padding-right: 9px;
    background: linear-gradient(to right, transparent, var(--color-bg-2) 28px);
    opacity: 0;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .review_section__file:hover .review_section__file_actions {
        opacity: 1;
        background: linear-gradient(to right, transparent, var(--color-bg-3) 28px);
    }
}

.review_section__file.active .review_section__file_actions {
    background: linear-gradient(to right, transparent, var(--color-bg-3) 28px);
}

@media (hover: none) {
    .review_section__file_actions {
        opacity: 1;
        background: linear-gradient(to right, transparent, var(--color-bg-2) 28px);
    }
}

.review_section__file_action {
    font-size: 15px;
    line-height: 1;
    color: var(--color-text-muted);
    cursor: pointer;
    padding: 0 4px;
    border-radius: 3px;
    transition: color 0.1s, background-color 0.1s;
}

@media (hover: none) {
    .review_section__file_action {
        font-size: 17px;
    }

    .review_section__file_path {
        font-size: 14px;
    }
}

@media (pointer: fine) {
    .review_section__file_action:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

@media (pointer: fine) {
    .review_section__file_action--remove:hover {
        color: #e05c5c;
        background-color: rgba(224, 92, 92, 0.12);
    }
}

/* Always visible while a request is in flight, not just on hover. */
.review_section__file_actions--pending {
    opacity: 1;
}

.review_section__file_action--pending {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1em;
    height: 1em;
    cursor: default;
}

.review_section__file_action--hidden {
    visibility: hidden;
}

.review_section__file_action_spinner {
    width: 9px;
    height: 9px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: review_section__spin 0.7s linear infinite;
}

/* Remove file confirmation */
/* Right pane */
.review_section__no_selection {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 13px;
    color: var(--color-text-muted);
}

.review_section__diff_placeholder {
    padding: 9px 13px;
    font-size: 13px;
    color: var(--color-text-muted);
}

.review_section__context_btn {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid var(--color-border);
    background: var(--color-bg-2);
    color: var(--color-text-muted);
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
    z-index: 10;
}

.review_section__context_btn--active {
    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, var(--color-bg-2));
    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);
    color: var(--color-accent, #4a6cf7);
}

@media (pointer: fine) {
    .review_section__context_btn:hover {
        background: var(--color-bg-3);
        color: var(--color-text);
        border-color: var(--color-border);
    }

    .review_section__context_btn--active:hover {
        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, var(--color-bg-2));
    }
}

.review_section__save_overlay {
    position: absolute;
    top: 46px;
    right: 8px;
    z-index: 100;
    display: flex;
    background: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    overflow: hidden;
}

.review_section__save_btn {
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.6;
    color: var(--color-text-muted);
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.12s, background-color 0.12s;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
}

@media (pointer: fine) {
    .review_section__save_btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}

.review_section__save_btn:disabled {
    cursor: default;
    opacity: 0.7;
}

.review_section__save_spinner {
    width: 10px;
    height: 10px;
    border: 2px solid var(--color-text-muted);
    border-top-color: transparent;
    border-radius: 50%;
    animation: review_save_spin 0.6s linear infinite;
    display: inline-block;
}

@keyframes review_save_spin {
    to { transform: rotate(360deg); }
}

.configure_vault_banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 13px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--color-accent);
    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 10%, var(--color-bg-2));
    border-top: 1px solid color-mix(in srgb, var(--color-accent, #4a6cf7) 25%, transparent);
    cursor: pointer;
    flex-shrink: 0;
    margin-top: auto;
    transition: background-color 0.15s;
}

@media (pointer: fine) {
    .configure_vault_banner:hover {
        background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 18%, var(--color-bg-2));
    }
}
`, "",{"version":3,"sources":["webpack://./components/sections/ReviewSection/s.review_section.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,oDAAoD;IACpD,cAAc;AAClB;;AAEA,kEAAkE;AAClE;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;IACjB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,6BAA6B;IAC7B,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,WAAW;AACf;;AAEA,qFAAqF;AACrF;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,6EAA6E;IAC7E,mFAAmF;IACnF,mCAAmC;IACnC,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,OAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0EAA0E;IAC1E,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;QACV,0EAA0E;IAC9E;AACJ;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI;QACI,UAAU;QACV,0EAA0E;IAC9E;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,cAAc;QACd,yCAAyC;IAC7C;AACJ;;AAEA,oEAAoE;AACpE;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA,6BAA6B;AAC7B,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,6BAA6B;IAC7B,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0DAA0D;IAC1D,WAAW;AACf;;AAEA;IACI,mFAAmF;IACnF,+EAA+E;IAC/E,mCAAmC;AACvC;;AAEA;IACI;QACI,6BAA6B;QAC7B,wBAAwB;QACxB,iCAAiC;IACrC;;IAEA;QACI,mFAAmF;IACvF;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,+CAA+C;IAC/C,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,6BAA6B;IAC7B,kBAAkB;IAClB,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,yFAAyF;IACzF,uFAAuF;IACvF,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,yFAAyF;IAC7F;AACJ","sourcesContent":[".review_section {\n    width: 100%;\n    height: 100%;\n}\n\n.review_section__active_path {\n    font-size: 11px;\n    font-weight: 400;\n    letter-spacing: 0;\n    text-transform: none;\n    color: var(--color-text-muted);\n    max-width: 160px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    direction: rtl;\n}\n\n.review_section--centered {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 13px;\n    padding: 35px;\n}\n\n.review_section__spinner {\n    width: 26px;\n    height: 26px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: review_section__spin 0.7s linear infinite;\n}\n\n@keyframes review_section__spin {\n    to { transform: rotate(360deg); }\n}\n\n.review_section__empty_icon {\n    font-size: 35px;\n    line-height: 1;\n    color: var(--color-text-muted);\n}\n\n.review_section__empty_title {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-text);\n    text-align: center;\n}\n\n.review_section__empty_desc {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    text-align: center;\n    max-width: 352px;\n    line-height: 1.5;\n}\n\n.review_section__action_btn {\n    margin-top: 4px;\n    padding: 7px 18px;\n    background-color: var(--color-accent);\n    color: #fff;\n    border-radius: 3px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .review_section__action_btn:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.review_section__action_btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n/* Panes */\n.review_section__pane {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n}\n\n.review_section__pane--sidebar {\n    background-color: var(--color-bg-2);\n}\n\n.review_section__pane_header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 9px 13px 4px;\n}\n\n.review_section__pane_label {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    user-select: none;\n    flex-shrink: 0;\n}\n\n.review_section__refresh_btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    font-size: 15px;\n    font-weight: normal;\n    letter-spacing: 0;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    line-height: 1;\n    border-radius: 3px;\n    transition: color 0.15s, background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .review_section__refresh_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.review_section__refresh_btn--active {\n    color: var(--color-accent);\n}\n\n\n.review_section__refresh_spinner {\n    width: 13px;\n    height: 13px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: review_section__spin 0.7s linear infinite;\n    flex-shrink: 0;\n}\n\n/* Branch select — flex sizing within this section's header/slot */\n.review_section__pane_header > .branch_select {\n    flex: 1 1 0;\n    min-width: 60px;\n}\n\n.accordion__header_slot .branch_select {\n    flex: 1 1 0;\n    min-width: 60px;\n}\n\n/* Commit area */\n.review_section__commit_area {\n    padding: 9px 13px;\n    border-bottom: 1px solid var(--color-border);\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 7px;\n    flex-shrink: 0;\n}\n\n.review_section__commit_input {\n    min-width: 0;\n    resize: none;\n    padding: 6px 8px;\n    font-size: 13px;\n    font-family: inherit;\n    background: var(--color-bg-3);\n    color: var(--color-text);\n    border: 1px solid var(--color-border);\n    border-radius: 3px;\n    outline: none;\n    box-sizing: border-box;\n    line-height: 1.4;\n    height: 28px;\n    overflow: hidden;\n    transition: height 0.15s;\n}\n\n.review_section__commit_input:focus {\n    border-color: var(--color-accent);\n    height: 68px;\n    overflow: auto;\n}\n\n.review_section__commit_error {\n    font-size: 12px;\n    color: #e05c5c;\n    width: 100%;\n}\n\n.review_section__merge_hint {\n    font-size: 12px;\n    color: var(--color-danger, #e53e3e);\n    width: 100%;\n}\n\n/* Repo-operation error banner: hidden entirely unless store.operationError is set. */\n.review_section__error_banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin: 8px;\n    padding: 8px 10px;\n    border-radius: 6px;\n    background: color-mix(in srgb, var(--color-danger, #e53e3e) 10%, transparent);\n    border: 1px solid color-mix(in srgb, var(--color-danger, #e53e3e) 35%, transparent);\n    color: var(--color-danger, #e53e3e);\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 1.5;\n}\n\n.review_section__error_banner_icon {\n    flex-shrink: 0;\n    font-family: sans-serif;\n}\n\n.review_section__error_banner_msg {\n    flex: 1;\n    min-width: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.review_section__error_banner_dismiss {\n    flex-shrink: 0;\n    cursor: pointer;\n    font-family: sans-serif;\n    font-size: 15px;\n    line-height: 1;\n    opacity: 0.7;\n}\n\n.review_section__error_banner_dismiss:hover {\n    opacity: 1;\n}\n\n.review_section__error_banner_title {\n    font-weight: bold;\n}\n\n.review_section__error_banner_hint {\n    margin-top: 4px;\n    font-size: 12px;\n    opacity: 0.8;\n}\n\n.review_section__conflict_files {\n    margin: 4px 0 0;\n    padding-left: 18px;\n}\n\n.review_section__merge_btn {\n    margin-top: 6px;\n    padding: 4px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 12px;\n    color: #fff;\n    background: var(--color-danger, #e53e3e);\n    border: none;\n}\n\n.review_section__merge_btn:disabled {\n    opacity: 0.6;\n    cursor: default;\n}\n\n.review_section__identity_form {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.review_section__identity_input {\n    max-width: 280px;\n}\n\n.review_section__commit_btn {\n    align-self: flex-end;\n    padding: 4px 15px;\n    font-size: 13px;\n    background-color: var(--color-accent);\n    color: #fff;\n    border-radius: 3px;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .review_section__commit_btn:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.review_section__commit_btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n/* File list */\n.review_section__file_list {\n    flex: 1;\n    overflow-y: auto;\n    padding-bottom: 9px;\n}\n\n.review_section__no_changes {\n    padding: 13px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.review_section__group {\n    margin-top: 4px;\n}\n\n.review_section__group_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 4px 9px 2px 13px;\n}\n\n.review_section__group_header_actions {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.review_section__group_label {\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    user-select: none;\n}\n\n.review_section__group_action {\n    font-size: 15px;\n    line-height: 1;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    padding: 1px 6px;\n    border-radius: 3px;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .review_section__group_action:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.review_section__file {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    width: 100%;\n    padding: 3px 13px;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 0;\n    transition: background-color 0.1s;\n}\n\n@media (hover: none) {\n    .review_section__file {\n        padding: 5px 13px;\n    }\n}\n\n@media (pointer: fine) {\n    .review_section__file:hover {\n        background-color: var(--color-bg-3);\n    }\n}\n\n.review_section__file.active {\n    background-color: var(--color-bg-3);\n    outline: 1px solid var(--color-accent);\n    outline-offset: -1px;\n}\n\n.review_section__file_status {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    min-width: 64px;\n    flex-shrink: 0;\n    text-transform: uppercase;\n}\n\n@media (hover: none) {\n    .review_section__file_status {\n        font-size: 12px;\n        min-width: 68px;\n    }\n}\n\n.review_section__file_status--staged {\n    color: #6ca35e;\n}\n\n.review_section__file_status--unstaged {\n    color: var(--color-accent);\n}\n\n.review_section__file_status--untracked {\n    color: var(--color-text-muted);\n}\n\n.review_section__file_status--deleted {\n    color: #e05c5c;\n}\n\n.review_section__file_status--conflicted {\n    color: var(--color-danger, #e53e3e);\n    font-weight: bold;\n}\n\n.review_section__file_status--resolved {\n    color: #6ca35e;\n}\n\n.review_section__file_path {\n    font-size: 13px;\n    color: var(--color-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n}\n\n.review_section__file_actions {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    padding-left: 28px;\n    padding-right: 9px;\n    background: linear-gradient(to right, transparent, var(--color-bg-2) 28px);\n    opacity: 0;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .review_section__file:hover .review_section__file_actions {\n        opacity: 1;\n        background: linear-gradient(to right, transparent, var(--color-bg-3) 28px);\n    }\n}\n\n.review_section__file.active .review_section__file_actions {\n    background: linear-gradient(to right, transparent, var(--color-bg-3) 28px);\n}\n\n@media (hover: none) {\n    .review_section__file_actions {\n        opacity: 1;\n        background: linear-gradient(to right, transparent, var(--color-bg-2) 28px);\n    }\n}\n\n.review_section__file_action {\n    font-size: 15px;\n    line-height: 1;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    padding: 0 4px;\n    border-radius: 3px;\n    transition: color 0.1s, background-color 0.1s;\n}\n\n@media (hover: none) {\n    .review_section__file_action {\n        font-size: 17px;\n    }\n\n    .review_section__file_path {\n        font-size: 14px;\n    }\n}\n\n@media (pointer: fine) {\n    .review_section__file_action:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n@media (pointer: fine) {\n    .review_section__file_action--remove:hover {\n        color: #e05c5c;\n        background-color: rgba(224, 92, 92, 0.12);\n    }\n}\n\n/* Always visible while a request is in flight, not just on hover. */\n.review_section__file_actions--pending {\n    opacity: 1;\n}\n\n.review_section__file_action--pending {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1em;\n    height: 1em;\n    cursor: default;\n}\n\n.review_section__file_action--hidden {\n    visibility: hidden;\n}\n\n.review_section__file_action_spinner {\n    width: 9px;\n    height: 9px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: review_section__spin 0.7s linear infinite;\n}\n\n/* Remove file confirmation */\n/* Right pane */\n.review_section__no_selection {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.review_section__diff_placeholder {\n    padding: 9px 13px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n}\n\n.review_section__context_btn {\n    position: absolute;\n    bottom: 12px;\n    right: 12px;\n    width: 28px;\n    height: 28px;\n    border-radius: 4px;\n    border: 1px solid var(--color-border);\n    background: var(--color-bg-2);\n    color: var(--color-text-muted);\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.1s, color 0.1s, border-color 0.1s;\n    z-index: 10;\n}\n\n.review_section__context_btn--active {\n    background: color-mix(in srgb, var(--color-accent, #4a6cf7) 20%, var(--color-bg-2));\n    border-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 60%, transparent);\n    color: var(--color-accent, #4a6cf7);\n}\n\n@media (pointer: fine) {\n    .review_section__context_btn:hover {\n        background: var(--color-bg-3);\n        color: var(--color-text);\n        border-color: var(--color-border);\n    }\n\n    .review_section__context_btn--active:hover {\n        background: color-mix(in srgb, var(--color-accent, #4a6cf7) 30%, var(--color-bg-2));\n    }\n}\n\n.review_section__save_overlay {\n    position: absolute;\n    top: 46px;\n    right: 8px;\n    z-index: 100;\n    display: flex;\n    background: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.review_section__save_btn {\n    padding: 3px 10px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.6;\n    color: var(--color-text-muted);\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: color 0.12s, background-color 0.12s;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n}\n\n@media (pointer: fine) {\n    .review_section__save_btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n\n.review_section__save_btn:disabled {\n    cursor: default;\n    opacity: 0.7;\n}\n\n.review_section__save_spinner {\n    width: 10px;\n    height: 10px;\n    border: 2px solid var(--color-text-muted);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: review_save_spin 0.6s linear infinite;\n    display: inline-block;\n}\n\n@keyframes review_save_spin {\n    to { transform: rotate(360deg); }\n}\n\n.configure_vault_banner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 8px 13px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: var(--color-accent);\n    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 10%, var(--color-bg-2));\n    border-top: 1px solid color-mix(in srgb, var(--color-accent, #4a6cf7) 25%, transparent);\n    cursor: pointer;\n    flex-shrink: 0;\n    margin-top: auto;\n    transition: background-color 0.15s;\n}\n\n@media (pointer: fine) {\n    .configure_vault_banner:hover {\n        background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 18%, var(--color-bg-2));\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
